export default __webpack_public_path__ + "static/media/torso-top-left-side.465c71c8.png";